import React from 'react'
import { Button, Col, Row, Spinner } from 'react-bootstrap';
import Pagination from '../Layout/Pagination';
import UseAllBrands from '../../CustomHooks/Brands/UseAllBrands';
import AdminBrandCard from './AdminBrandCard';
import { ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';

const AdminAllBrandsComp = () => {

    const [loading, allBrands, pageCount, onPress, SearchValue, ChangeInputSearch] = UseAllBrands();

    return (
        <>
            <div className='d-flex flex-row justify-content-between m-3  mt-5 align-items-center'>
                <h3 className='fw-bold'>All Brands</h3>
                <Link to="/admin/addbrand">
                    <Button className='dark-bg border-0 px-4 py-3'>Add New Brand</Button>
                </Link>
            </div>
            <div className='d-flex flex-row justify-content-between mx-3 mb-2 align-items-center'>
                <input type='text' className='form-control h-60 mb-4 fs-20 fw-bold' placeholder='Search by brand name' value={SearchValue} onChange={ChangeInputSearch} />
            </div>
            {loading === true ? (<div className='d-flex justify-content-center align-items-center mt-5 pt-5'>
                <Spinner animation="border" variant="danger" />
            </div>) :
                (allBrands && allBrands.length > 0 ? (
                    <Row className="m-1 d-flex">
                        {allBrands ? (
                            allBrands.map((item, index) => {
                                let imageUrl = item.image;
                                return (
                                    <Col
                                        xl="3"
                                        lg="4"
                                        sm="6">
                                        <AdminBrandCard
                                            key={index}
                                            img={imageUrl}
                                            cardText={item.name}
                                            id={item._id}
                                        />
                                    </Col>
                                );
                            })
                        ) : (
                            <h1>No Brands to show</h1>
                        )}
                        .
                    </Row>
                ) :
                    <div className='d-flex  align-items-center flex-column h-100'>
                        <h3 className='alert alert-danger'>No Brands to show, Add new brand to show</h3>
                        <Link to="/admin/addbrand">
                            <Button className='dark-bg border-0 px-4 py-3'>Add New brand</Button>
                        </Link>
                    </div>
                )}
            {pageCount > 1 ? (<Pagination pageCount={pageCount} onPress={onPress} />) : null}
            <ToastContainer />
        </>
    )
}

export default AdminAllBrandsComp
